const Dashboard = {
  name: 'Inicio',
  link: '/dashboard',
  // iconclass: 'ion-home',
  imgpath: 'assets/img/icons/aperture.svg',
  order: 0
};

const Administracion = {
  name: 'Administracion',
  link: '/administracion',
  imgpath: 'assets/img/icons/connection-bars.svg',
  order: 1,
  subitems: [{
    name: 'Etiquetas',
    role_required: 'ROLE_ADMIN',
    link: '/administracion/organizacion/0/etiquetas'
  }, {
    name: 'Banco de query',
    role_required: 'ROLE_ADMIN',
    link: '/administracion/banco-query'
  }, {
    name: 'Organizaciones',
    link: '/administracion/organizacion'
  }, {
    name: 'Proyectos',
    link: '/administracion/proyectos'
  }, {
    name: 'Cuestionarios',
    link: '/administracion/cuestionarios'
  }, {
    name: 'Actualizaciones iMm@',
    link: '/administracion/bitacora'
  }, {
    name: 'Informes',
    link: '/administracion/informes'
  }, {
    name: 'Comparativa',
    link: '/administracion/comparar'
  }]
};

const Usuarios = {
    name: 'Usuarios',
    link: 'usuarios',
    order: 6,
    role_required: 'ROLE_ADMIN',
    // iconclass: 'ion-person-stalker',
    imgpath: 'assets/img/icons/person-stalker.svg',
    subitems: [{
        name: 'Usuarios',
        link: '/usuarios/administrar'
    }]
};


export const menu = [
  Dashboard,
  Administracion,
  Usuarios
];



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts